import { render, staticRenderFns } from "./prompt-group-deletion.vue?vue&type=template&id=7061acc7"
import script from "./prompt-group-deletion.vue?vue&type=script&lang=js"
export * from "./prompt-group-deletion.vue?vue&type=script&lang=js"
import style0 from "./prompt-group-deletion.vue?vue&type=style&index=0&id=7061acc7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports